"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = default_1;
const UserPhotoLayer_1 = require("../../models/layers/UserPhotoLayer");
const Printable_1 = require("../../models/printables/Printable");
const either_1 = require("../../types/either");
const layers_1 = require("../layers");
function default_1(project, action) {
  const printableGroupIndex = project.printableGroups.findIndex(pg => pg.id === action.printableGroupId);
  if (printableGroupIndex === -1) {
    return (0, either_1.left)(new Error(`Could not find printable group with id '${action.printableGroupId}'.`));
  }
  project.printableGroups[printableGroupIndex].rotateWorkspace = action.rotateWorkspace;
  const updatedPrintables = [];
  for (let printableIdx = 0; printableIdx < project.printableGroups[printableGroupIndex].printables.length; printableIdx += 1) {
    const printableUpdated = (0, Printable_1.updatePrintableVersion)(project.printableGroups[printableGroupIndex].printables[printableIdx], action.timestamp);
    let layerUpdated = false;
    for (let layerIdx = 0; layerIdx < printableUpdated.layers.length; layerIdx += 1) {
      const layer = printableUpdated.layers[layerIdx];
      if ((0, UserPhotoLayer_1.isFilledUserPhotoLayer)(layer) && (0, layers_1.userPhotoLayerHasMaxCrop)(layer.userData)) {
        layerUpdated = true;
        const newUserDataResult = (0, layers_1.getCropForUserPhotoLayerInPrintableInProject)(printableUpdated, layer.id, action.rotateWorkspace, undefined);
        if (newUserDataResult.isLeft()) {
          return (0, either_1.left)(newUserDataResult.value);
        }
        printableUpdated.layers[layerIdx] = Object.assign(Object.assign({}, layer), {
          userData: newUserDataResult.value
        });
      }
    }
    if (layerUpdated) {
      project.printableGroups[printableGroupIndex].printables[printableIdx] = printableUpdated;
      updatedPrintables.push(printableUpdated);
    }
  }
  return (0, either_1.right)({
    updatedProject: project,
    updatedEntities: [project, ...updatedPrintables]
  });
}